export default "__VITE_ASSET__e262e1be__"